/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitoringTimePackageDTO
 */
export interface MonitoringTimePackageDTO {
    /**
     * 
     * @type {Date}
     * @memberof MonitoringTimePackageDTO
     */
    creationDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof MonitoringTimePackageDTO
     */
    expirationDate: Date;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTimePackageDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringTimePackageDTO
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof MonitoringTimePackageDTO
     */
    priceInCents: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoringTimePackageDTO
     */
    secondsInPackage: number;
    /**
     * 
     * @type {number}
     * @memberof MonitoringTimePackageDTO
     */
    secondsUsed: number;
}

/**
 * Check if a given object implements the MonitoringTimePackageDTO interface.
 */
export function instanceOfMonitoringTimePackageDTO(value: object): value is MonitoringTimePackageDTO {
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('expirationDate' in value) || value['expirationDate'] === undefined) return false;
    if (!('priceInCents' in value) || value['priceInCents'] === undefined) return false;
    if (!('secondsInPackage' in value) || value['secondsInPackage'] === undefined) return false;
    if (!('secondsUsed' in value) || value['secondsUsed'] === undefined) return false;
    return true;
}

export function MonitoringTimePackageDTOFromJSON(json: any): MonitoringTimePackageDTO {
    return MonitoringTimePackageDTOFromJSONTyped(json, false);
}

export function MonitoringTimePackageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoringTimePackageDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'creationDate': (new Date(json['creationDate'])),
        'expirationDate': (new Date(json['expirationDate'])),
        'label': json['label'] == null ? undefined : json['label'],
        'description': json['description'] == null ? undefined : json['description'],
        'priceInCents': json['priceInCents'],
        'secondsInPackage': json['secondsInPackage'],
        'secondsUsed': json['secondsUsed'],
    };
}

export function MonitoringTimePackageDTOToJSON(value?: MonitoringTimePackageDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'creationDate': ((value['creationDate']).toISOString()),
        'expirationDate': ((value['expirationDate']).toISOString()),
        'label': value['label'],
        'description': value['description'],
        'priceInCents': value['priceInCents'],
        'secondsInPackage': value['secondsInPackage'],
        'secondsUsed': value['secondsUsed'],
    };
}

